module.exports = __webpack_public_path__ + "img/signupIllustration.44c49c52.svg";